import { render, staticRenderFns } from "./UpperNavbar.vue?vue&type=template&id=ff298e86&"
import script from "./UpperNavbar.vue?vue&type=script&lang=js&"
export * from "./UpperNavbar.vue?vue&type=script&lang=js&"
import style0 from "./UpperNavbar.vue?vue&type=style&index=0&id=ff298e86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports